import request from '@/util/request'
// 当前登录者的商家信息
export function userMy () {
  return request({
    url: `/user-s/acc/org`,
    method: 'get',
    params:{language:stage.languageId}
  })
}
//更新商家logo
export function updateMyLogo (data) {
  return request({
    url: `/user-s/acc/org/my/logo`,
    method: 'post',
    data
  })
}

// 获取所有的外部角色
export function entityRelsAll () {
  return request({
    url: `/user-s/acc/entity-rels`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/manage/user.js